// src/util/extractors.ts

import ncsRefJson from "../data/NCS_REF.json";
const ncsRef: any = ncsRefJson;

/**
 * 추출: Motor Nerve 리스트 (nerve - rec 형태)
 */
export const extractMotorNerves = (): string[] => {
  const motor = ncsRef?.Motor;
  if (!motor) return [];

  const results = new Set<string>();

  Object.keys(motor).forEach((nerve) => {
    const segments = motor[nerve].segments;
    Object.keys(segments).forEach((seg) => {
      const [stim, rec] = seg.split("-");
      results.add(`${nerve} - ${rec}`);
    });
  });

  return Array.from(results).sort();
};

/**
 * 추출: 특정 Motor Nerve에서 stim site 리스트
 */
export const extractStimSites = (nerve: string, rec: string): string[] => {
  const motor = ncsRef?.Motor;
  if (!motor?.[nerve]) return [];

  return Object.keys(motor[nerve].segments)
    .filter((s) => s.endsWith(`-${rec}`))
    .map((s) => s.split("-")[0]);
};

/**
 * 추출: 모든 Stim site 리스트 (중복 제거)
 */
export const extractStimSitesFlat = (): string[] => {
  const motor = ncsRef?.Motor;
  const sites = new Set<string>();

  Object.values(motor || {}).forEach((n) => {
    Object.keys((n as any).segments).forEach((seg) => {
      const [stim] = seg.split("-");
      sites.add(stim);
    });
  });

  return Array.from(sites).sort();
};

/**
 * 추출: Sensory nerve 이름 리스트
 */
export const extractSensoryNerves = (): string[] => {
  return Object.keys(ncsRef?.Sensory || {}).sort();
};

/**
 * 추출: Rec site (Recording site) 리스트
 */
export const extractRecSites = (): string[] => {
  const motor = ncsRef?.Motor;
  const sites = new Set<string>();

  Object.values(motor || {}).forEach((n) => {
    Object.keys((n as any).segments).forEach((seg) => {
      const [, rec] = seg.split("-");
      sites.add(rec);
    });
  });

  return Array.from(sites).sort();
};

/**
 * 추출: stim site 리스트 by nerve + rec site
 */
export const getMotorSegments = (nerve: string, muscle: string): string[] => {
  const motor = (ncsRef as any)?.Motor;
  if (!motor?.[nerve]) return [];

  const allSegments = Object.keys(motor[nerve].segments);
  return allSegments
    .filter((s) => s.endsWith(`-${muscle}`))
    .map((s) => s.split("-")[0]);
};
